// Explicit synthetic preview data. Never used as component defaults.
import { ART_BASE } from '../assets.js';
const ASSET = ART_BASE;

export const FIXTURE_KIDS = [
  { id: 'maya', name: 'Maya', age: 9, avatar: `${ASSET}/avatar-kid-1.jpg` },
  { id: 'leo', name: 'Leo', age: 11, avatar: `${ASSET}/avatar-kid-2.jpg` },
  { id: 'finn', name: 'Finn', age: 6, avatar: `${ASSET}/avatar-kid-3.jpg` },
];

export const FIXTURE_PACKS = [
  {
    id: 'little-helpers',
    title: 'Little Helpers',
    age: 'Ages 5–7 · matched to Finn',
    icons: [
      { src: `${ASSET}/icon-bed.png`, alt: 'Make the bed' },
      { src: `${ASSET}/icon-plant.png`, alt: 'Water the plants' },
      { src: `${ASSET}/icon-broom.png`, alt: 'Tidy up' },
    ],
    questCount: 6,
    valueLabel: '$0.25–$0.50 each',
    added: true,
  },
  {
    id: 'village-keepers',
    title: 'Village Keepers',
    age: 'Ages 8–11 · matched to Maya & Leo',
    icons: [
      { src: `${ASSET}/icon-dishes.png`, alt: 'Dishes' },
      { src: `${ASSET}/icon-trash.png`, alt: 'Take out trash' },
      { src: `${ASSET}/icon-homework.png`, alt: 'Homework' },
    ],
    questCount: 8,
    valueLabel: '$0.50–$1.25 each',
    added: true,
  },
  {
    id: 'weekend-reset',
    title: 'Weekend Reset',
    age: 'Whole family · Sat–Sun',
    icons: [
      { src: `${ASSET}/icon-laundry.png`, alt: 'Laundry' },
      { src: `${ASSET}/icon-broom.png`, alt: 'Sweep' },
      { src: `${ASSET}/icon-bed.png`, alt: 'Change sheets' },
    ],
    questCount: 5,
    valueLabel: '$0.75–$1.50 each',
    added: false,
  },
  {
    id: 'pet-care',
    title: 'Pet Care',
    age: 'Any age · daily',
    icons: [
      { src: `${ASSET}/icon-dog.png`, alt: 'Walk the dog' },
      { src: `${ASSET}/icon-dishes.png`, alt: 'Fill food bowl' },
      { src: `${ASSET}/icon-broom.png`, alt: 'Clean up' },
    ],
    questCount: 4,
    valueLabel: '$0.50–$1.00 each',
    added: false,
  },
];

export const FIXTURE_QUESTS = [
  { id: 'q-dishes', title: 'Unload the dishwasher', icon: `${ASSET}/icon-dishes.png`, who: 'Maya', avatar: `${ASSET}/avatar-kid-1.jpg`, reward: 0.75 },
  { id: 'q-trash', title: 'Take out the trash', icon: `${ASSET}/icon-trash.png`, who: 'Leo', avatar: `${ASSET}/avatar-kid-2.jpg`, reward: 0.5 },
  { id: 'q-homework', title: 'Homework check-in', icon: `${ASSET}/icon-homework.png`, who: 'Leo', avatar: `${ASSET}/avatar-kid-2.jpg`, reward: 1.0 },
  { id: 'q-bed', title: 'Make the bed', icon: `${ASSET}/icon-bed.png`, who: 'Finn', avatar: `${ASSET}/avatar-kid-3.jpg`, reward: 0.25 },
  { id: 'q-plant', title: 'Water the plants', icon: `${ASSET}/icon-plant.png`, who: 'Finn', avatar: `${ASSET}/avatar-kid-3.jpg`, reward: 0.25 },
  { id: 'q-sweep', title: 'Sweep the kitchen', icon: `${ASSET}/icon-broom.png`, who: 'Maya', avatar: `${ASSET}/avatar-kid-1.jpg`, reward: 0.75 },
];

export const onboardingFixture = {
  kids: FIXTURE_KIDS,
  packs: FIXTURE_PACKS,
  quests: FIXTURE_QUESTS,
  familyName: 'Silva',
  paydayDay: 5,
};
